import Routes from "./Routes.js";

function App() {
  return (
    <>
      <Routes />
    </>
  );
}

export default App;
